import React from 'react';
import { Section } from './ui/Section';
import { FileText, ShoppingCart, ArrowLeftRight, Shield, Copy } from 'lucide-react';
export function WhatsIncluded() {
  const features = [{
    icon: FileText,
    title: '4 menús listos',
    desc: '1 persona / pareja / familia / bajo presupuesto'
  }, {
    icon: ShoppingCart,
    title: 'Listas de compras por pasillos',
    desc: 'Imprimible + versión "captura"'
  }, {
    icon: ArrowLeftRight,
    title: 'Swaps inteligentes',
    desc: 'Si no hay X, hacés Y (sin dramatizar)'
  }, {
    icon: Shield,
    title: 'Plan de emergencia',
    desc: '10 opciones salvavidas para cuando no cocinaste'
  }, {
    icon: Copy,
    title: 'Plantillas',
    desc: 'Para repetir cada semana sin volver a pensar desde cero'
  }];
  return <Section data-id="element-213">
      <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-214">
        Qué incluye (y por qué es diferente)
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-215">
        {features.map((feature, idx) => <div key={idx} className="p-5 bg-white rounded-xl border border-stone-100 shadow-sm flex flex-col gap-2" data-id="element-216">
            <div className="flex items-center gap-3 mb-1" data-id="element-217">
              <feature.icon className="w-5 h-5 text-sage" data-id="element-218" />
              <h3 className="font-bold text-lg" data-id="element-219">{feature.title}</h3>
            </div>
            <p className="text-brown-body pl-8" data-id="element-220">{feature.desc}</p>
          </div>)}
      </div>

      <p className="text-center text-xl font-medium text-brown-heading" data-id="element-221">
        Todo en un PDF directo, sin relleno.
      </p>
    </Section>;
}